module.exports = __webpack_public_path__ + "static/keller-williams-0371d9979b756d9b58d46105214c00e0.webp";